import {
    SET_NEXT_PREVIEWS_INFO,
    SET_SEARCH_TEXT,
    SET_TRACK,
} from '../types';


export const setNextPreviewsInfo = (previewsInfo) => (dispatch) => {
    if (previewsInfo) {
        dispatch({
            type: SET_NEXT_PREVIEWS_INFO,
            payload: {
                previewsInfo: previewsInfo.slice(0, 30)
            },
        });
    } else {
        dispatch({
            type: SET_NEXT_PREVIEWS_INFO,
            payload: null,
        });
    }
}


export const setTrack = (track) => (dispatch) => {
    dispatch({
        type: SET_TRACK,
        payload: track,
    });
}


export const setSearchText = (text) => (dispatch) => {
    dispatch({
        type: SET_SEARCH_TEXT,
        payload: text,
    });
}
